var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"หวยตัวอย่าง รอบวันที่"}}),_c('LottoDemoForm'),(_vm.lottoDemo)?[_c('LottoDemoBetList',{attrs:{"id":_vm.lottoDemo.id}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }